import { request } from '@blade/common';
const serveName = 'camera-device-management';
export const postDevicesGroupTree = () => request({
    url: `/api/${serveName}/api/v1/device-groups/devices/tree`,
    method: 'POST',
    data: { 'groupId': 0 }
});
export const getRtspPreviewAddress = (deviceId) => request({
    url: `/api/${serveName}/api/v1/devices/${deviceId}/rtsp_preview_address`,
    method: 'GET',
    params: {}
});
export const getPassConfig = (deviceId) => request({
    url: `/api/iot-device-management/api/v2/iot/devices/passXconfig/${deviceId}`,
    method: 'GET',
});
export const updatePassConfig = (data) => request({
    url: `/api/iot-device-management/api/v2/iot/devices/passXconfig`,
    method: 'POST',
    data
});
export const updatePosition = (data) => request({
    url: `/api/iot-device-management/api/v2/iot/devices/${data.deviceId}/addVertices`,
    method: 'POST',
    data
});
export const getDevicesDetail = (deviceId) => request({
    url: `/api/iot-device-management/api/v2/iot/devices/simple/${deviceId}`,
    method: 'GET',
});
